/**
 * Browser API Polyfills
 *
 * This file contains polyfills for browser APIs that are not universally supported.
 * Import this file early in your application initialization to ensure compatibility.
 */

/**
 * requestIdleCallback Polyfill
 *
 * Safari doesn't support requestIdleCallback as of Safari 18.6 (January 2026).
 * While WebKit implemented it in July 2024, it was subsequently disabled due to regressions.
 *
 * This polyfill provides a fallback using setTimeout when the native API is not available.
 *
 * @see https://bugs.webkit.org/show_bug.cgi?id=285049
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
 */
export const requestIdleCallbackPolyfill =
  typeof window !== 'undefined' && window.requestIdleCallback
    ? window.requestIdleCallback.bind(window)
    : (callback, options) => {
        const timeout = options?.timeout || 0;
        return setTimeout(callback, timeout);
      };

/**
 * cancelIdleCallback Polyfill
 *
 * Companion to requestIdleCallback for canceling scheduled callbacks.
 */
export const cancelIdleCallbackPolyfill =
  typeof window !== 'undefined' && window.cancelIdleCallback
    ? window.cancelIdleCallback.bind(window)
    : clearTimeout;
